<template>
  <div class="box">
    <div class="introduction-title">
      <img :src="detail.imagePath || detail.productLogo"
           alt="" />
      <div>
        <div class="title">
          {{ detail.name }}
        </div>
        <div class="price">
          保险额度：
          <span style="color: red; font-weight: 700; margin-right: 20px">{{
            detail.sumInsured || detail.productExpandInfo
          }}</span>
          <!-- 价格：
          <span style="color: red; font-weight: 700; margin-right: 20px"
            >{{ detail.unitPrice }}元/人/月</span
          >
          预估总价：
          <span style="color: red; font-weight: 700"
            >{{
              detail.thirdpartyState &&
              (detail.totalMoney || detail.totalMoney == 0)
                ? detail.totalMoney
                : total
            }}元</span
          > -->
        </div>
        <div class="myForm">
          <el-form ref="form"
                   :inline="true"
                   :model="form"
                   label-width="95px"
                   :rules="rules"
                   size="mini"
                   v-enterToNext="true">
            <el-form-item label="投保方式："
                          prop="insureWay">
              <div v-if="orderFlag"
                   style="width: 25px">
                {{ form.insureWay == 2 ? "年" : "月" }}
              </div>

              <el-radio-group v-model="form.insureWay"
                              v-else>
                <el-radio-button label="2">年</el-radio-button>
                <el-radio-button label="1">月</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="开始日期："
                          prop="startDate">
              <div v-if="orderFlag">
                {{ form.startDate && form.startDate.slice(0, 10) }}
              </div>

              <el-date-picker style="width: 100%"
                              v-model="form.startDate"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期"
                              @change="addThirtyDays"
                              v-else>
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item
              v-if="form.endDate && $route.query.orderStateInt == 2"
              label="结束日期："
              prop="startDate"
            >
              {{ form.endDate && form.endDate.slice(0, 10) }}
            </el-form-item> -->
            <el-form-item label="结束日期："
                          prop="endDate">
              <div v-if="orderFlag">
                {{ form.endDate && form.endDate.slice(0, 10) }}
              </div>

              <el-date-picker style="width: 100%"
                              v-model="form.endDate"
                              :picker-options="pickerOptionsEnd"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期"
                              v-else>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="投保单位："
                          prop="insuredCompanyId">
              <div v-if="orderFlag"
                   style="
                  width: 190px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                ">
                {{ $refs.myCompany.selected.label }}
              </div>
              <el-select v-model="form.insuredCompanyId"
                         clearable
                         filterable
                         placeholder="请选择投保单位"
                         ref="myCompany"
                         @change="changeCompany"
                         v-show="!orderFlag">
                <el-option v-for="item in companyList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label-width="110px"
                          label="被投保单位："
                          prop="passivityInsuredCompanyId">
              <div v-if="orderFlag"
                   style="
                  width: 190px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                ">
                {{ $refs.myCompany2.selected.label }}
              </div>

              <el-select v-model="form.passivityInsuredCompanyId"
                         clearable
                         filterable
                         placeholder="请选择被投保单位"
                         ref="myCompany2"
                         @change="changeCompany2"
                         v-show="!orderFlag">
                <el-option v-for="item in companyList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <span v-if="!orderFlag && verifyPermission('AddInsuredUnit')"
                  style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
                margin: 0 8px;
                line-height: 28px;
              "
                  @click="addCustomerDrawerShow = true">新增投保单位</span>
          </el-form>
        </div>
      </div>

      <div class="btn">
        <el-button plain
                   size="mini"
                   @click="back"
                   :loading="submitLoading">上一步</el-button>
      </div>
    </div>
    <el-divider content-position="center">选择投保人员</el-divider>
    <div class="baseForm-title">
      被投保人信息
      <div>
        <el-button icon="el-icon-upload"
                   :loading="submitLoading"
                   size="small"
                   v-if="!orderFlag"
                   @click="noticeDialogVisible = true"
                   type="success">录入人员</el-button>
        <el-button icon="el-icon-edit"
                   plain
                   :loading="submitLoading"
                   size="small"
                   v-if="!orderFlag"
                   @click="batchChange(2)"
                   type="success">批量修改健康信息</el-button>
        <el-button icon="el-icon-edit"
                   plain
                   :loading="submitLoading"
                   size="small"
                   v-if="!orderFlag"
                   @click="batchChange(1)"
                   type="success">批量修改工种</el-button>
        <el-button size="small "
                   type="primary"
                   v-if="!orderFlag"
                   plain
                   :loading="submitLoading"
                   @click="del"
                   icon="el-icon-delete">删除</el-button>
      </div>
    </div>
    <MyTable :tableData="tableData"
             :tableConfig="tableConfig"
             :tableType="!orderFlag ? 'selection' : ''"
             @selectionChange="handleSelectionChange"
             :height="'46vh'"
             ref="multipleTable"
             :indexFlag="true"
             @EmptyBtn="noticeDialogVisible = true"
             tableEmptyText="暂无数据，请录入人员">
      <template v-slot:index="slotData">
        {{ slotData.scope.$index + 1 }}
      </template>
      <template v-slot:cname="slotData">
        <div v-if="orderFlag">{{ slotData.scope.row.cname }}</div>
        <el-input v-else
                  size="small"
                  :class="flag == slotData.scope.$index + 'cname' ? 'inputDeep' : ''"
                  v-model="slotData.scope.row.cname"></el-input>
      </template>
      <template v-slot:identityCard="slotData">
        <div v-if="orderFlag">{{ slotData.scope.row.identityCard }}</div>

        <el-input v-else
                  size="small"
                  maxlength="18"
                  :class="
            flag == slotData.scope.$index + 'identityCard' ? 'inputDeep' : ''
          "
                  v-model="slotData.scope.row.identityCard"></el-input>
      </template>
      <template v-slot:sex="slotData">
        <div v-if="orderFlag">{{ slotData.scope.row.sex }}</div>

        <el-select v-model="slotData.scope.row.sex"
                   filterable
                   placeholder="请选择"
                   :class="flag == slotData.scope.$index + 'sex' ? 'inputDeep' : ''"
                   v-else>
          <el-option label="男"
                     value="男"></el-option>
          <el-option label="女"
                     value="女"></el-option>
        </el-select>
      </template>
      <template v-slot:healthStateText="slotData">
        <div v-if="orderFlag">{{ slotData.scope.row.healthStateText }}</div>
        <el-select v-model="slotData.scope.row.healthStateInt"
                   placeholder="请选择健康信息"
                   size="small"
                   :class="
            flag == slotData.scope.$index + 'healthStateText' ? 'inputDeep' : ''
          "
                   @change="healthchange($event, slotData.scope.$index)"
                   :ref="'myHealthSelected' + slotData.scope.$index"
                   v-else>
          <el-option v-for="item in HealthList"
                     :key="item.Value"
                     :label="item.Description || item.description"
                     :value="item.value || item.Value">
          </el-option>
        </el-select>

        <!-- <el-input
          v-else
          size="small"
          v-model="slotData.scope.row.healthStateText"
        ></el-input> -->
      </template>
      <template v-slot:insuranceWorkCategoryName="slotData">
        <div v-if="orderFlag">
          {{ slotData.scope.row.insuranceWorkCategoryName }}
        </div>
        <el-input v-else
                  size="small"
                  readonly
                  :class="
            flag == slotData.scope.$index + 'insuranceWorkCategoryName'
              ? 'inputDeep'
              : ''
          "
                  v-model="slotData.scope.row.myName"
                  @focus="change(slotData.scope.row)"></el-input>
      </template>
    </MyTable>

    <el-dialog title="批量健康信息"
               :visible.sync="healthVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px">
      <el-form ref="inputForm2"
               :model="inputForm"
               :rules="rules"
               label-width="auto"
               v-enterToNext="true">
        <el-form-item label="健康信息"
                      prop="healthStateInt">
          <el-select v-model="inputForm.healthStateInt"
                     placeholder="请选择健康信息"
                     ref="healthBatchSelect">
            <el-option v-for="item in HealthList"
                       :key="item.Value"
                       :label="item.Description || item.description"
                       :value="item.value || item.Value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              (inputForm = {}), (healthVisible = false);
            }
          ">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="send('inputForm2', 2)">确 定</el-button>
      </span>
    </el-dialog>
    <div style="text-align: center; padding-top: 20px"
         v-if="!btnFlag">
      <el-button v-if="orderFlag"
                 plain
                 size="small"
                 @click="orderFlag = !orderFlag">修改</el-button>
      <el-button size="small"
                 plain
                 @click="SaveData()"
                 :loading="submitLoading"
                 type="primary">{{ "暂存信息" }}</el-button>
      <el-button size="small"
                 @click="go('form')"
                 :loading="submitLoading"
                 type="primary">{{ !orderFlag ? "确认信息" : "提交订单" }}</el-button>
    </div>
    <AddCustomer :drawerShow="addCustomerDrawerShow"
                 operation="add"
                 title="新增投保单位"
                 @colseDrawer="addCustomerDrawerShow = false"
                 @refreshData="getCompanyList" />
    <notifyCard @colseDrawer="noticeDialogVisible = false"
                :visible.sync="noticeDialogVisible"
                @add="add"
                :filterate="tableData" />
    <jobMacting :visible="jobMactingVisible"
                @close="jobMactingVisible = false"
                :posName="form.position"
                type="2"
                :industry="industry"
                @enter="enter"></jobMacting>
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import notifyCard from "./notifyCard.vue";
import AddCustomer from "../insuredUnit/AddCustomer.vue";
import jobMacting from "@/components/jobMatching";
import { verifyPermissionMinix } from "@/utils/mixin";
import { baseUrl } from "../../request/url";
import { commonAddMouth } from "../../utils/function";
import * as insure from "@/insure/index";
import IDCard from "china-id-card";
export default {
  components: {
    MyTable,
    notifyCard,
    AddCustomer,
    jobMacting,
  },
  mixins: [verifyPermissionMinix],
  props: {
    orderDetail: Object,
    // 1 编辑
    type: String,
    orderTableData: Array,
  },
  data () {
    return {
      activeName: "first",
      noticeDialogVisible: false,
      tableConfig: [
        {
          field: "cname",
          label: "姓名",
          align: "center",
          slotName: "cname",
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证",
          align: "center",
          slotName: "identityCard",
          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",
          slotName: "sex",
          flag: true,
        },
        {
          field: "healthStateText",
          label: "健康信息",
          align: "center",
          slotName: "healthStateText",
          flag: true,
        },
        {
          field: "insuranceWorkCategoryName",
          label: "工种名称",
          align: "center",
          slotName: "insuranceWorkCategoryName",
          flag: true,
        },
        {
          field: "insuranceWorkCategoryCode",
          label: "工种代码",
          align: "center",
          flag: true,
        },
      ],
      tableData: [],
      addCustomerDrawerShow: false,
      flag: "",
      loading: false,
      fileVisible: false,
      companyList: [],
      categoryList: [],
      submitLoading: false,
      healthVisible: false,
      detail: "",
      form: { insureWay: "1" },
      inputForm: {},
      timeVal: [new Date() - 3600 * 1000 * 24 * 3, new Date()],
      pickerOptions: {
        disabledDate: (time) => {
          // 这个是当前日期后的日期不可选
          if (!this.form.endDate) {
            return time.getTime() < Date.now();
          } else {
            return (
              time.getTime() < Date.now()
              // ||
              // time.getTime() > new Date(this.form.endDate)
            );
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          // 这个是当前日期后的日期不可选
          if (this.form.startDate) {
            return time.getTime() < new Date(this.form.startDate);
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      tipVisible: false,
      rules: {
        insureWay: [
          {
            required: true,
            message: "请选择投保方式",
            trigger: ["blur", "change"],
          },
        ],
        insuranceWorkCategoryCode: [
          {
            required: true,
            message: "请选择工种",
            trigger: ["blur"],
          },
        ],
        insuredCompanyId: [
          {
            required: true,
            message: "请选择投保单位",
            trigger: ["blur"],
          },
        ],
        passivityInsuredCompanyId: [
          {
            required: true,
            message: "请选择被投保单位",
            trigger: ["blur"],
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始日期",
            trigger: ["blur"],
          },
        ],
        healthStateInt: [
          {
            required: true,
            message: "请选择健康信息",
            trigger: ["blur"],
          },
        ],
      },
      Ids: "",
      allCategoryList: [],
      items: [],
      insuredCompanyId: "",
      orderFlag: false,
      HealthList: [],
      selective: {},
      companyName: "",
      token: "",
      List: [],
      btnFlag: false,
      thirdpartyInsuranceKey: "",
      jobMactingVisible: false,
      industry: "",
    };
  },
  computed: {
    total () {
      let num = 0;
      if (this.form.insureWay == 1) {
        num = this.detail.unitPrice * this.tableData.length;
      } else {
        num = this.detail.twoPrice * this.tableData.length;
      }
      return num;
    },
  },

  async mounted () {
    //编辑

    if (this.type == 1) {
      if (this.$route.query.orderFlag) {
        this.orderFlag = JSON.parse(this.$route.query.orderFlag);
        this.btnFlag = JSON.parse(this.$route.query.orderFlag);
      }
    } else {
      //新增获取详情
      this.detail = JSON.parse(localStorage.getItem("detail"));
    }
    this.companyName = this.$store.state.companyName
      ? this.$store.state.companyName
      : JSON.parse(localStorage.getItem("CompanyDetail")).companyName;
    if (this.type != 1) {
      this.$set(this.form, "startDate", this.getNowFormatDate());
      this.addThirtyDays(this.getNowFormatDate());
      // await insure.InsuranceCompanyDetail(this.detail.insuranceCompanyId);
      // insure.reg_log(this);
    }

    this.getCompanyList();
    this.getEnumerationData();
    // this.YangGuangRegister();
  },
  watch: {
    orderTableData (newValue, old) {
      this.tableData = newValue;
    },
    async orderDetail (newValue, old) {
      this.detail = newValue;
      this.$set(this, "form", newValue);
      // await insure.InsuranceCompanyDetail(this.detail.insuranceCompanyId);
      // insure.reg_log(this);
    },
  },
  methods: {
    addThirtyDays (value) {
      // value.split("-")
      let temp = new Date(value.split("-")[0], value.split("-")[1], 0);

      if (value) {
        const date = new Date(value);
        date.setDate(date.getDate() + temp.getDate() - 1);
        this.$set(this.form, "endDate", date);
      }
    },
    changeCompany2 (value) {
      for (var i = 0; i < this.companyList.length; i++) {
        if (
          this.companyList[i].id == value &&
          this.companyList[i].isCompleteInformation == false
        ) {
          this.$message.error("投保单位信息未完善，请前往投保单位完善！");
          this.form.insuredCompanyId = "";
          this.form.passivityInsuredCompanyId = "";
          return;
        }
      }
      this.$set(this.form, "insuredCompanyId", value);
    },
    changeCompany (value) {
      console.log(1, value);
      for (var i = 0; i < this.companyList.length; i++) {
        if (
          this.companyList[i].id == value &&
          this.companyList[i].isCompleteInformation == false
        ) {
          this.$message.error("投保单位信息未完善，请前往投保单位完善！");
          this.form.insuredCompanyId = "";
          this.form.passivityInsuredCompanyId = "";
          return;
        }
      }
      this.$set(this.form, "passivityInsuredCompanyId", value);
    },
    getEnumerationData () {
      this.$api.base.getEnumerationData("HealthState").then((res) => {
        if (res.error === false || res.Error === false) {
          this.HealthList = res.data || res.Data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getCompanyList () {
      console.log(55);
      this.$api.Insurance.InsureUnitList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getNowFormatDate () {
      let date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`;
    },
    batchChange (flag) {
      if (this.tableData.length <= 0) {
        return this.$message.warning("请至少录入一条数据");
      }
      if (this.items.length <= 0) {
        this.$refs.multipleTable.toggleAllSelection();
      }

      if (flag == 1) {
        // this.tipVisible = true;
        this.jobMactingVisible = true;
      } else {
        this.healthVisible = true;
      }
      // this.$nextTick(() => {
      //   this.items.forEach((item) => {
      //     this.$set(
      //       item,
      //       "insuranceWorkCategoryCode",
      //       this.form.insuranceWorkCategoryCode
      //     );
      //     this.$set(
      //       item,
      //       "insuranceWorkCategoryName",
      //       this.$refs.batchSelect.selected.label
      //     );
      //   });
      // });
    },
    send (formName, flag) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        if (flag == 1) {
          this.$nextTick(() => {
            this.items.forEach((item) => {
              this.$set(
                item,
                "insuranceWorkCategoryCode",
                this.inputForm.insuranceWorkCategoryCode
              );
              this.$set(
                item,
                "workTypeCode",
                this.inputForm.insuranceWorkCategoryCode
              );
              this.$set(
                item,
                "myName",
                this.inputForm.insuranceWorkCategoryCode
              );
              this.$set(
                item,
                "insuranceWorkCategoryName",
                this.$refs.batchSelect.selected.label
              );
            });
            this.inputForm = {};
            this.tipVisible = false;
            // this.$refs.multipleTable.clearSelection();
          });
        } else {
          this.$nextTick(() => {
            this.items.forEach((item) => {
              this.$set(
                item,
                "healthStateText",
                this.$refs.healthBatchSelect.selected.label
              );
              this.$set(
                item,
                "healthy",
                this.$refs.healthBatchSelect.selected.label
              );
              this.$set(item, "healthStateInt", this.inputForm.healthStateInt);
            });
            console.log(this.items);
            this.inputForm = {};
            this.healthVisible = false;
            // this.$refs.multipleTable.clearSelection();
          });
        }
      });
    },
    //批量选择工种
    enter (value) {
      this.$nextTick(() => {
        this.items.forEach((item) => {
          this.$set(item, "insuranceWorkCategoryCode", value.occupationCode);
          this.$set(item, "workTypeCode", value.occupationCode);
          this.$set(item, "myName", value.standardName);
          this.$set(item, "insuranceWorkCategoryName", value.standardName);
        });
        // this.items = [];
        this.jobMactingVisible = false;
        // this.$refs.multipleTable.clearSelection();
      });
    },
    change (value) {
      this.items[0] = value;
      this.jobMactingVisible = true;
      // console.log(value);
      // this.$nextTick(() => {
      //   this.$set(this.tableData[index], "insuranceWorkCategoryCode", value);
      //   this.$set(this.tableData[index], "workTypeCode", value);
      //   this.$set(
      //     this.tableData[index],
      //     "insuranceWorkCategoryName",
      //     this.$refs["mySelected" + index].selected.label
      //   );
      // });
    },
    healthchange (value, index) {
      this.$nextTick(() => {
        this.$set(
          this.tableData[index],
          "healthStateText",
          this.$refs["myHealthSelected" + index].selected.label
        );
        this.$set(
          this.tableData[index],
          "healthy",
          this.$refs["myHealthSelected" + index].selected.label
        );
        // this.$set(
        //   this.tableData[index],
        //   "insuranceWorkCategoryName",
        //   this.$refs["mySelected" + index].selected.label
        // );
      });
    },
    add (value) {
      this.tableData.push.apply(this.tableData, value);
      this.$forceUpdate();
    },
    del () {
      this.Ids.forEach((v) => {
        this.tableData.forEach((item, i) => {
          if (item.id == v) {
            this.tableData.splice(i, 1);
          }
        });
      });
    },
    handleSelectionChange (selection) {
      console.log(selection);
      this.Ids = selection.map((v) => {
        return v.id;
      });
      this.items = selection.map((v) => {
        return v;
      });
    },
    back () {
      if (this.type != 1) {
        this.$router.push({ path: "/insuranceList", query: { flag: 1 } });
      } else {
        this.$router.push({ path: "/insuranceOrders" });
      }
    },
    // 新增第三方投保单位信息
    // EnterpriseEdit(res, value, id) {
    //   let flag = res;
    //   if (!value) {
    //     // 新增
    //     let sendData = res;
    //     sendData.token = this.token;
    //     // 有第三方信息就传入id进行编辑
    //     sendData.code = res.creditCode;
    //     sendData.businessLicenseJson = "https:" + res.businessLicencePath;
    //     sendData.cityCode = res.provincialandCivicCode.split(",")[2];
    //     sendData.zipCode = res.postcode;
    //     sendData.username = this.$store.state.companyName;

    //     this.$api.Insurance.YangGuangEnterpriseAdd(sendData).then((res) => {
    //     
    //       if (res.error === false) {
    //         this.insuredCompanyId = res.data;
    //         this.MatchingUnitInfo(flag, res, id);
    //         this.OrderPrePerson();
    //       } else {
    //         this.$message.error(res.msg);
    //         this.submitLoading = false;
    //       }
    //     });
    //   } else {
    //     this.OrderPrePerson();
    //   }
    // },

    //匹配第三方单位信息
    // MatchingUnitInfo(res, thirdlyId, unitId) {
    //   let sendData = {
    //     insureCompanyId: this.detail.insuranceCompanyId,
    //     unitId: unitId,
    //     thirdlyId: thirdlyId.data,
    //   };
    //   this.$api.Insurance.MatchingUnitInfo(sendData).then((res) => {
    //   
    //     if (res.error === false) {
    //       this.submitLoading = false;
    //     } else {
    //       this.submitLoading = false;

    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // 确认信息和提交订单
    go (formName) {
      if (this.tableData.length < 5) {
        this.$message.warning("投保人数不能少于5人!");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        if (this.tableData.length <= 0) {
          return this.$message.warning("请录入人员");
        }
        for (let i = 0; i < this.tableData.length; i++) {
          if (!this.tableData[i].cname) {
            this.$message.warning("姓名不能为空");
            this.flag = i + "cname";
            return;
          }
          if (!this.tableData[i].identityCard) {
            this.$message.warning("身份证不能为空");
            this.flag = i + "identityCard";
            return;
          }
          if (this.tableData[i].identityCard) {
            if (IDCard(this.tableData[i].identityCard).isVerified == true) {
              console.log(1);
            } else {
              this.$message.warning(
                "身份证号码不正确-" + this.tableData[i].identityCard
              );
              this.flag = i + "identityCard";

              return;
            }
          }
          if (!this.tableData[i].sex) {
            this.$message.warning("性别不能为空");
            this.flag = i + "sex";

            return;
          }
          if (!this.tableData[i].healthStateText) {
            this.$message.warning("健康信息不能为空");
            this.flag = i + "healthStateText";

            return;
          }
          if (!this.tableData[i].insuranceWorkCategoryName) {
            this.$message.warning("工种名称不能为空");
            this.flag = i + "insuranceWorkCategoryName";

            return;
          }
        }
        insure.creat_submit(this);
        return;
        //判断有没有预处理人员
        if (this.orderFlag == false) {
          this.submitLoading = true;
          // 检查投保单位
          insure.CheckThirdlyUnit(this);
        } else {
          insure.creat_submit(this);
          // this.$confirm(
          //   "支付方式支持微信支付（保险订单生效时间为T+1）及企业对公转账（保险订单生效时间为T+1），确认提交订单吗?",
          //   "提示",
          //   {
          //     confirmButtonText: "确 认",
          //     cancelButtonText: "关 闭",
          //     type: "warning",
          //   }
          // )
          //   .then(() => {
          //     this.submitLoading = true;
          //     let sendData = {
          //       insuredCompanyId: this.form.insuredCompanyId,
          //       insuredCompanyName: this.$refs.myCompany.selected.label,
          //       insureProductCompanyName: this.detail.insuranceCompanyName,
          //       insureProductCompanyId: this.detail.insuranceCompanyId,
          //       passivityInsuredCompanyId: this.form.passivityInsuredCompanyId,
          //       passivityInsuredCompanyName:
          //         this.$refs.myCompany2.selected.label,
          //       startDate: this.form.startDate,
          //       thirdlyProductId: this.detail.thirdlyId,
          //       endDate:
          //         this.form.insureWay == "2"
          //           ? commonAddMouth(this.form.startDate, 12, 0)
          //           : commonAddMouth(this.form.startDate, 1, 0),
          //       insuranceProductId:
          //         this.type != 1
          //           ? this.detail.id
          //           : this.detail.insuranceProductId,
          //       insureWay: this.form.insureWay,
          //       insureWayText: this.form.insureWay == 2 ? "年" : "月",
          //       insuranceOrderTheInsuredList: this.tableData,
          //       state: 1,
          //     };

          //     if (this.$route.query.id) {
          //       sendData.id = this.$route.query.id;
          //     }
          //     this.$api.Insurance[
          //       this.type != 1 ? "InsuranceCompanyCreateOrder" : "SubmitData"
          //     ](sendData).then((res) => {
          //       this.submitLoading = false;

          //       if (res.error === false) {
          //         this.SynchronizationThirdlyKeyVal(res.data);
          //       } else {
          //         this.$message.error(res.msg);
          //       }
          //     });
          //   })
          //   .catch(() => {});
        }
      });
    },

    SaveData () {
      insure.SaveData(this);
      // this.$confirm("确认保存订单信息吗?", "提示", {
      //   confirmButtonText: "确 认",
      //   cancelButtonText: "关 闭",
      //   type: "warning",
      // }).then(() => {
      //   this.submitLoading = true;
      //   let sendData = {
      //     insuredCompanyId: this.form.insuredCompanyId,
      //     insuredCompanyName: this.$refs.myCompany.selected.label,
      //     insureProductCompanyName: this.detail.insuranceCompanyName,
      //     insureProductCompanyId: this.detail.insuranceCompanyId,
      //     passivityInsuredCompanyId: this.form.passivityInsuredCompanyId,
      //     passivityInsuredCompanyName: this.$refs.myCompany2.selected.label,
      //     thirdlyProductId: this.detail.thirdlyId,
      //     startDate: this.form.startDate,
      //     endDate:
      //       this.form.insureWay == "2"
      //         ? commonAddMouth(this.form.startDate, 12, 0)
      //         : commonAddMouth(this.form.startDate, 1, 0),
      //     insuranceProductId:
      //       this.type != 1 ? this.detail.id : this.detail.insuranceProductId,
      //     insureWay: this.form.insureWay,
      //     insureWayText: this.form.insureWay == 2 ? "年" : "月",
      //     insuranceOrderTheInsuredList: this.tableData,
      //     state: 0,
      //   };
      //   if (this.$route.query.id) {
      //     sendData.id = this.$route.query.id;
      //   }
      //   this.$api.Insurance.SaveData(sendData).then((res) => {
      //     this.submitLoading = false;
      //     if (res.error === false) {
      //     
      //       this.$message.success("保存成功");
      //       this.$router.replace("/insuranceOrders");
      //       // this.OrderPrePerson(res.data);
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
      // });
    },
    // CheckThirdlyUnit() {
    //   let sendData = {
    //     unitId: this.form.insuredCompanyId,
    //     insureCompanyId:
    //       this.type != 1
    //         ? this.detail.insuranceCompanyId
    //         : this.detail.insureProductCompanyId,
    //   };
    //   // 检查是否有第三方投保单位信息
    //   this.$api.Insurance.CheckThirdlyUnit(sendData).then((res) => {
    //     if (res.error === false) {
    //       let sendData = {
    //         id: this.form.passivityInsuredCompanyId,
    //       };

    //       if (res.data) {
    //         this.insuredCompanyId = res.data.thirdlyId;
    //       }
    //       let check = res.data;
    //       // 获取系统的投保单位信息
    //       this.$api.Insurance.InsureUnitDetail(sendData).then((res) => {
    //       
    //         if (res.error == false) {
    //           this.submitLoading = false;

    //           this.EnterpriseEdit(res.data, check, res.data.id);
    //         } else {
    //           this.submitLoading = false;
    //           this.$message.error(res.msg);
    //         }
    //       });
    //     } else {
    //       this.submitLoading = false;
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // SynchronizationThirdlyKeyVal(orderNo) {
    //   let sendData = {
    //     orderNo: orderNo,
    //     thirdpartyInsuranceKey: this.thirdpartyInsuranceKey,
    //   };

    //   this.$api.Insurance.SynchronizationThirdlyKeyVal(sendData).then((res) => {
    //   
    //     if (res.error == false) {
    //       this.$message.success("提交成功");
    //       this.$router.replace("/insuranceOrders");
    //       let href = `${baseUrl.sunlightWebsite}/authorization?token=${this.token}&redirectPage=/order/edit&policyCompanyId=${this.insuredCompanyId}&insuredCompanyId=${this.insuredCompanyId}&preAddPersonKey=${this.thirdpartyInsuranceKey}&insurancePlanItemId=${this.detail.thirdlyId}&outTradeNo=${orderNo}`;
    //       window.open(href, "_blank");
    //       this.orderFlag = true;
    //     } else {
    //       this.submitLoading = false;
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    //第三方的预处理人员
    // OrderPrePerson(outTradeNo) {
    //   let personList = [];
    //   this.tableData.forEach((item) => {
    //     let obj = {};
    //     obj.idcard = item.identityCard;
    //     obj.name = item.cname;
    //     obj.workTypeCode = item.workTypeCode;
    //     obj.healthy = item.healthy;
    //     personList.push(obj);
    //   });

    //   let sendData = {
    //     username: this.companyName,
    //     insurancePlanItemId: this.detail.thirdlyId,
    //     insuredCompanyId: this.insuredCompanyId,
    //     personList: personList,
    //   };
    //   this.$api.Insurance.OrderPrePerson(sendData).then((res) => {
    //     this.submitLoading = false;

    //     if (res.error === false) {
    //       this.orderFlag = true;
    //       // thirdpartyInsuranceKey 第三方的key
    //       this.thirdpartyInsuranceKey = res.data;
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
  },
};
</script>
<style lang="less">
.el-scrollbar {
  max-width: 350px !important;
}
.inputDeep {
  .el-input__inner {
    border: 1px solid red !important; //边框颜色
  }
}
.treeDeep {
  .vue-treeselect__control {
    border: 1px solid red !important; //边框颜色
  }
}
</style>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 76vh;
  background-color: #fff;
  padding: 20px;
  // padding-bottom: 30px;
  overflow: auto;
  .introduction-title {
    width: 100%;
    // height: 110px;
    display: flex;
    margin-bottom: 10px;
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      bottom: 18px;
      z-index: 999;
    }
    img {
      width: 110px;
      height: 110px;
      border-radius: 8px;
    }
    .title {
      margin-left: 15px;
      font-size: 19px;
      font-weight: 700;
    }
    .myForm {
      margin-top: 20px;
      margin-left: 15px;
    }
  }
  .price {
    font-weight: normal;
    font-size: 16px;
    margin-left: 15px;
    margin-top: 20px;
  }
  .baseForm-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
</style>